import { machineLocal } from '~/data/local';
import { machineRemote } from '~/data/remote';
import { OperatingTimePayload } from '~/machines/store/machine';
import store from '~/store';
import { syncTypes } from '~/sqlite/syncDataTypes';

import { SyncHandlerOutcome, SyncTypeHandler } from './types';

export class OperatingDataSyncHandler implements SyncTypeHandler {
  readonly syncType = syncTypes.UPDATE_OPERATING_DATA;

  async process(_row: unknown, requestData: Record<string, unknown>): Promise<SyncHandlerOutcome> {
    await machineRemote.registerOperatingTime({
      ...requestData,
      sync: 1,
    } as OperatingTimePayload);

    if (requestData.machineId != null) {
      const type = Number(requestData.type);
      await machineLocal.clearOperatingPendingSync(String(requestData.machineId), type);
      store.getActions().machine.clearOperatingDataPendingSync({
        machineId: String(requestData.machineId),
        type: type as OperatingTimePayload['type'],
      });
    }

    return {
      removeQueueRow: true,
      localFilePathsToDelete: [],
      machineIdToRefresh: requestData.machineId
        ? String(requestData.machineId)
        : undefined,
    };
  }
}

export const operatingDataSyncHandler = new OperatingDataSyncHandler();
